// https://docs.videojs.com/utils_str.js.html
export const toLowerCase = function (string: string) {
  if (typeof string !== 'string') {
    return string;
  }

  return string.replace(/./, (w) => w.toLowerCase());
};

export const toTitleCase = function (string: string) {
  if (typeof string !== 'string') {
    return string;
  }

  return string.replace(/./, (w) => w.toUpperCase());
};

export const titleCaseEquals = function (str1: string, str2: string) {
  return toTitleCase(str1) === toTitleCase(str2);
};

export const createWeakRandomString = () =>
  (Math.random() + 1).toString(36).substring(7);
